import { DateTime } from 'luxon';
import { Injectable } from '@angular/core';
import { JsonSerializable } from '../models/models';
import { DATE_TIME_NON_ZULU_ISO_DATE_TIME_FORMAT } from '../shared/date-helper';

export interface UrlMatrixParam {
    propertyName: string;
    propertyType: string;
    propertyValue: {};
}

@Injectable()
export class HttpJsonUtilities {
    public concatenateToMatrixUrlParams(params: UrlMatrixParam[]): string {
        let formatedString = '';
        params.forEach(element => {
            // eslint-disable-next-line eqeqeq
            if (element.propertyValue != undefined) {
                formatedString += element.propertyName + ':' + this.toJson(element.propertyType, element.propertyValue) + ';';
            }
        });

        return formatedString;
    }

    public toMatrixUrlParams(object: {}): string {
        let formatedString = '';
        for (const property in object) {
            if (object.hasOwnProperty(property)) {
                const value = object[property];
                // eslint-disable-next-line eqeqeq
                if (value != undefined) {
                    const valueString: string = this.toJson(undefined, value);
                    formatedString += property + ':' + valueString + ';';
                }
            }
        }
        return formatedString;
    }

    public fromJson(typeName: string, value: any): any {
      // eslint-disable-next-line eqeqeq
        if (value != undefined && typeName === 'luxon.DateTime') {
            return DateTime.fromISO(value);
        }

        return value;
    }

    public toJson(typeName: string, value: any): string {
      if (typeName === 'string' && (!value || value.trim() === '')) {
          return undefined;
      }

      // eslint-disable-next-line eqeqeq
      if (value != undefined) {
          if (value instanceof JsonSerializable) {
              return value.toJson();
          }
          if (typeName === 'luxon.DateTime') {
              return value.toFormat(DATE_TIME_NON_ZULU_ISO_DATE_TIME_FORMAT);
          }
          return value + '';
      }

      return '';
    }
}
